import * as React from "react";
import { ComponentProps } from "react";
import { styled } from "styled-components";

import { Extendable, ExtendableRow } from "./extendable";
/* stylelint-disable */
const TableEl = styled.table<{ $sticky?: boolean }>`
  border: 1px solid ${(props) => props.theme.colours.borders};
  background: ${(props) => props.theme.colours.white};
  border-radius: 6px;
  color: ${(props) => props.theme.colours.body};
  border-style: hidden;
  /* border-collapse: collapse; can't be used with sticky header, borders will 
  disappear for header. border-spacing: 0 is used, and cells bordered individually  
   */
  border-spacing: 0;
  width: 100%;
  position: relative;
  td,
  th {
    padding: 1rem;
    text-align: left;
    border-left: 1px solid ${(props) => props.theme.colours.bordersLight};
    border-bottom: 1px solid ${(props) => props.theme.colours.bordersLight};
    vertical-align: text-top;
    font-weight: normal;
  }
  td.bold {
    font-weight: bold;
  }
  td.no-wrap {
    white-space: nowrap;
  }
  thead {
    text-align: left;
    th {
      ${({ $sticky }) =>
        $sticky
          ? `
      position: sticky;
      box-shadow: 0px 3px 0px 0 rgb(191 191 191 / 26%);
      `
          : ""}
      top: 0;
      background: white;
      border-top: 1px solid ${(props) => props.theme.colours.bordersLight};
      font-weight: bold;

      &:first-child {
        border-radius: 6px 0 0 0;
      }
      &:last-child {
        border-radius: 0 6px 0 0;
        border-right: 1px solid ${(props) => props.theme.colours.bordersLight};
      }
    }
  }
  tr td:last-child {
    border-right: 1px solid ${(props) => props.theme.colours.bordersLight};
  }
  .isExtended + tr {
    td:first-child {
      border-bottom: none;
    }
  }
  tbody tr:last-child {
    th,
    td {
      &:last-child {
        border-radius: 0 0 6px 0;
      }
      &:first-child {
        border-radius: 0 0 0 6px;
      }
    }
  }
  td.extended {
    border-bottom: none;
  }
`;
/* stylelint-enable */
export const Table: React.FC<ComponentProps<typeof TableEl> & { sticky?: boolean }> & {
  Extendable: typeof Extendable;
  ExtendableRow: typeof ExtendableRow;
} = ({ sticky, ...props }) => <TableEl $sticky={sticky} {...props} />;

Table.Extendable = Extendable;
Table.ExtendableRow = ExtendableRow;
